import { getDateInFormat } from "@domains/utils/reportDates";
export var ClientProfileDetailsMapper = function (clientdtl) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var clientdata = {
        clientProfile: [],
    };
    var clientNameOverviewObj = {
        title: "Name",
        value: clientdtl.data.clientName,
        view360Link: true,
    };
    clientdata.clientProfile.push(clientNameOverviewObj);
    var clientEmailOverViewObj = {
        title: "Email ID",
        value: clientdtl.data.emailId,
        tag: false,
        tagValue: "DND",
    };
    clientdata.clientProfile.push(clientEmailOverViewObj);
    var clientMobileOverviewObj = {
        title: "Mobile",
        value: "".concat(((_a = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _a === void 0 ? void 0 : _a.countryprefix) ? "+" + ((_b = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _b === void 0 ? void 0 : _b.countryprefix) : "", " ").concat(clientdtl.data.mobileNo),
        tag: false,
        tagValue: "DND",
    };
    clientdata.clientProfile.push(clientMobileOverviewObj);
    var clientStatusOverviewObj = {
        title: "Status",
        value: clientdtl.data.status,
    };
    clientdata.clientProfile.push(clientStatusOverviewObj);
    var clientEngagementDateOverviewObj = {
        title: "Last Engagement Date",
        value: clientdtl.data.lastEngagementDate !== null
            ? getDateInFormat(clientdtl.data.lastEngagementDate, "DD MMM YYYY")
            : "-",
    };
    clientdata.clientProfile.push(clientEngagementDateOverviewObj);
    var clientProfilerOverviewObj = {
        title: "Profiler",
        value: clientdtl.data.profilePercentage + "%",
        link: true,
    };
    clientdata.clientProfile.push(clientProfilerOverviewObj);
    clientdata.lastprofilingDate = clientdtl.data.lastprofilingDate;
    clientdata.profilerPath = (_c = clientdtl.data) === null || _c === void 0 ? void 0 : _c.profilerPath;
    clientdata.responsedate = (_d = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _d === void 0 ? void 0 : _d.responsedate;
    clientdata.isShowProfileUpdatePopUp = (_e = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _e === void 0 ? void 0 : _e.isShowpop;
    clientdata.countryPrefix = (_f = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _f === void 0 ? void 0 : _f.countryprefix;
    clientdata.country = (_g = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _g === void 0 ? void 0 : _g.country;
    clientdata.nriNonNri = (_h = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _h === void 0 ? void 0 : _h.nrinonnri;
    clientdata.countryShortCode = (_j = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _j === void 0 ? void 0 : _j.countryshortcode;
    clientdata.nriNonNriId = (_k = clientdtl === null || clientdtl === void 0 ? void 0 : clientdtl.data) === null || _k === void 0 ? void 0 : _k.nrinonnriid;
    return clientdata;
};
